$(() => {
  $('.modal[data-default-open]').modal('show');
});
